import { call, put, takeEvery } from 'redux-saga/effects'
import { types, IGetMediaTypesAction } from '../types/mediaTypes'
import * as actions from '../actions/mediaTypes'
import * as services from '../services/mediaType'
import { trace } from '../services/common'

export function* getMediaTypesSaga(action: IGetMediaTypesAction) {
  try {
    const list = yield call(services.getMediaTypes, {
      orderBy: 'priority',
      order: 'asc',
    })
    yield put(actions.getMediaTypesSuccess(list))
  } catch (err) {
    trace(err)
    yield put(actions.getMediaTypesFailure(err.message))
  }
}

export function* mediaTypesWatcher() {
  yield takeEvery(types.GET_MEDIA_TYPES__STARTED, getMediaTypesSaga)
}
